export enum TranscriptContextWindowBehaviour {
    STATIC,
    START_DEFINED,
    TAILING
}